import { AnimatePresence } from 'motion/react';

import { VDialog } from '../VDialog';
import { VStack } from '../VStack';
import { joinCn } from '../util';
import VToastItem from './VToastItem';
import { useVToast } from './hook';

const VToastContainer = () => {
  const { toastList } = useVToast();

  return (
    <VDialog
      visible={true}
      disabledBackdrop
      dialogMainClass={joinCn('!bg-transparent !p-4 !shadow-none', {
        'pointer-events-none': toastList.length === 0,
      })}
      position="top-right"
    >
      <VStack gap={1} items="end" className="p-2">
        <AnimatePresence mode="popLayout">
          {toastList.map(item => (
            <VToastItem key={item.id} toast={item} />
          ))}
        </AnimatePresence>
      </VStack>
    </VDialog>
  );
};

export default VToastContainer;
